var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgZendesk = function SvgZendesk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#749E00",
    d: "M7.39 5.169v8.83H0l7.39-8.83ZM7.39 2c0 .97-.389 1.9-1.082 2.586a3.715 3.715 0 0 1-2.613 1.071c-.98 0-1.92-.385-2.613-1.071A3.638 3.638 0 0 1 0 2h7.39Zm1.218 12c0-.97.39-1.9 1.082-2.586a3.715 3.715 0 0 1 2.613-1.071c.98 0 1.92.385 2.613 1.071A3.638 3.638 0 0 1 15.998 14h-7.39Zm0-3.169V2H16l-7.392 8.83v.001Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZendesk);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;